// extracted by mini-css-extract-plugin
export var contrastLow = "_3p-1";
export var externalLink = "_3p-2";
export var externalLinkIcon = "_3p-3";
export var link = "_3p-0";
export var linkLabel = "_3p-4";